var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maskIndex',{on:{"close":_vm.close}},[_c('div',{staticClass:"centerBox",attrs:{"slot":"centerBox"},slot:"centerBox"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"html-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }